import colors, { PROFILE_PICTURE_PLACEHOLDER } from '@lmc/common/constants'
import { Avatar, Tooltip } from 'antd'
import type React from 'react'

export interface CarersCellProps {
  carers: {
    id: string
    name: { first: string; last: string }
    picture: string
  }[]
  tooltip?: boolean
}
export const CarersCell: React.FC<CarersCellProps> = ({
  carers,
  tooltip = true
}) => {
  const carersList = carers?.map((carer) =>
    tooltip ? (
      <Tooltip
        key={carer.id}
        title={`${carer.name?.first} ${carer.name?.last}`}
      >
        <Avatar src={carer.picture ?? PROFILE_PICTURE_PLACEHOLDER}>
          {carer.name?.first} {carer.name?.last}
        </Avatar>
      </Tooltip>
    ) : (
      <Avatar key={carer.id} src={carer.picture ?? PROFILE_PICTURE_PLACEHOLDER}>
        {carer.name?.first} {carer.name?.last}
      </Avatar>
    )
  )
  return (
    <Avatar.Group
      maxCount={3}
      maxStyle={{
        color: colors.pink,
        backgroundColor: colors.palerose,
        border: `1px solid ${colors.pink}`
      }}
    >
      {carersList}
    </Avatar.Group>
  )
}
